module.exports = __webpack_public_path__ + "img/p3@2x.612a28fd.png";